module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/9200459659/results02-b5a9a650d4460b7a5a77c8bce07d7348.png";